//* Libraries imports
import { Check, CopyAll } from "@mui/icons-material";
import { Typography, Tooltip, IconButton } from "@mui/material";
import { useState } from "react";

//*Types Imports
import { ExtendedPhaseForm } from "@/schemas";

type CopyFormButtonProps = {
  selectForm: ExtendedPhaseForm | null;
  productId?: string;
  clientId?: string;
};

export function CopyFormButton({
  selectForm,
  productId,
  clientId,
}: CopyFormButtonProps) {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = () => {
    if (!selectForm) return;

    const processId = "new";
    const id = selectForm.phaseFormId || selectForm._id;
    const normalizedProductId = productId || (clientId ? "null" : "");
    let formUrl = `${window.location.origin}/forms/${id}/${processId}`;

    if (normalizedProductId) {
      formUrl += `/${normalizedProductId}`;
    }

    if (clientId) {
      formUrl += `/${clientId}`;
    }

    navigator.clipboard
      .writeText(formUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  };

  if (!selectForm) return null;

  return (
    <div className="flex items-center justify-center gap-1">
      <Typography
        variant="body2"
        className="text-gray-500"
        style={{ cursor: "pointer" }}
        onClick={handleCopy}
      >
        Copiar link do formulário
      </Typography>
      <Tooltip title={copied ? "Copiado!" : "Copiar link"}>
        <IconButton size="small" onClick={handleCopy}>
          {copied ? (
            <Check fontSize="small" className="text-green-500" />
          ) : (
            <CopyAll fontSize="small" className="text-gray-400" />
          )}
        </IconButton>
      </Tooltip>
    </div>
  );
}
